
const SnsMini = require("./SnsMini")

let sns = xClass("snsOppoQuickgame", SnsMini)

sns.prototype.ctor = function() {
    SnsMini.prototype.ctor.call(this);
    this._adDcName = 'oppo_video_ad';
    mini.initAd("30098064");
}

/**
 * 转译广告位
 */
sns.prototype._translateAdPos = function(adPos = "FailAdd1Step", useDefaultId = false) {
    return '285507';
}

sns.prototype.getOpenKey = function (cb) {
    var self = this
    console.log("SnsOppoQuickgame getOpenKey start...");
    mini.login({
        success:(res)=>{
            console.log("SnsOppoQuickgame login success")
            console.log("SnsOppoQuickgame login data:"+JSON.stringify(res.data))
            //token = res.data.token
            META.tokenid = res.data.token
            if (cb){
                cb({   
                    pkgName:"com.happyelements.clover.h5.nearme.gamecenter",
                    token:res.data.token
                })
            }
        },
        fail:(res)=>{
            console.log("SnsOppoQuickgame login failed")
        }
    })


    return
}

sns.prototype.onLoginFinish = function(openid, sessionid){
    console.log("[####]oppo login finish openid:"+openid+" sess:"+sessionid)
    if (openid && sessionid){
        META.user.openid = openid
        META.user.sessionid = sessionid
        //cc.UserDefault.getInstance().setStringForKey("h5game_openid", openid)
        //cc.UserDefault.getInstance().setStringForKey("h5sdk_sessionid", sessionid)
    }else{
        console.log("[####]oppo login finish failed no openid or sessionid")
    }

}
sns.prototype.openUrl = function () {
    // 微信不能跳转
}

sns.prototype.hideKeyboard = function () {
    // 微信不能跳转
    mini.hideKeyboard()
}


sns.prototype.share = function (textId, platform, title, imageUrl, _link, callback) {
    
}

sns.prototype.popBack = function () {
    mini.exitMiniProgram({})
}

sns.prototype.alert = function (content, onClickOk) {
    mini.showModal({
        showCancel: false,
        content: content,
        success: onClickOk
    })
}

sns.prototype.drawDataToImg = function (bgpath, info, callback) {

}

sns.prototype.showGridAd = function(config){
    console.warn("not support grid ad");
}

/**
 * 显示插屏广告用
 */
sns.prototype.setNeedShowInterstitialAdName = function(name, flag) {
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    this.needShowInterstitialAdName[name] = flag;
}

sns.prototype.getNeedShowInterstitialAdName = function(name) {
    cc.log(this.needShowInterstitialAdName)
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    return this.needShowInterstitialAdName[name];
}

module.exports = sns